// src/icons/YoutubeIcon.js
import React from 'react';

const YoutubeIcon = ({ size = 24, color = "currentColor" }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        fill={color}
    >
        <path d="M23.498 6.186a2.865 2.865 0 00-2.01-2.023C19.51 3.6 12 3.6 12 3.6s-7.51 0-9.488.563a2.865 2.865 0 00-2.01 2.023A29.687 29.687 0 000 12a29.684 29.684 0 00.502 5.814 2.865 2.865 0 002.01 2.023C4.49 20.4 12 20.4 12 20.4s7.51 0 9.488-.563a2.865 2.865 0 002.01-2.023A29.687 29.687 0 0024 12a29.684 29.684 0 00-.502-5.814zM9.75 15.625V8.375l6.5 3.625-6.5 3.625z" />
    </svg>
);

export default YoutubeIcon;
